<template>
  <div class="row">
    <div v-if="loading" class="col" >
      <span class="loading text-muted">Loading...</span>
    </div>
    <div v-if="!loading" class="col" >
      <div style="position:fixed; right:35px; top: 10px;">
        <div class="row align-items-center">
          <div><small class="text-muted mr-2">LOW</small></div>
          <div style="width: 10px; height: 5px; background-color: #e5e5e5; border-radius: 10px 0 0 10px;"></div>
          <div style="height: 5px; background-color: #e5e5e5; font-size: 10px"><div style="margin-top: -4px"><i class="fa fa-plus"></i></div></div>
          <div style="width: 10px; height: 5px; background-color: #e5e5e5; border-radius: 0 10px 10px 0;"></div>
          <div><small class="text-muted ml-2">HIGH</small></div>
        </div>
        <div class="row d-flex text-center">
          <small style="width: 100%" class="text-muted text-center">Typical</small>
        </div>
      </div>
      <scatter-chart
        style="height:200px;"
        :chartdata="chartdata"
        :options="options"
        />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

import ScatterChart from '../../components/chart/ScatterChart.vue'

import apiService from '../../services/api.service'

import { checkResponseErrors } from '../../utils/http'
import moment from 'moment'

export default {
  name: 'CostTonneKmWidget',
  data: () => ({
    loading: true,
    chartdata: null,
    options: null,
  }),
  components: {
    ScatterChart
  },
  async mounted () {
    this.loading = true;

    try {
      const resp = await apiService.get('/dashboard/costTonneKM');
      if(await checkResponseErrors(resp)) return;

      // Chart
      this.chartdata = initWidgetData(resp.data);
      this.options = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        elements: {
          line: {
            fill: false,
            borderColor: (ctx) => {
              return getDatasetBackgroundColor(ctx.dataset.label);
            }
          },
          point: {
            radius: (ctx) => {
              return ctx.dataIndex == 1? 5: (ctx.dataset.data.length == 1? 3: 0);
            },
            pointStyle: (ctx) => {
              return ctx.dataIndex == 1? 'cross' : 'circle';
            },
            borderColor: (ctx) => {
              return ctx.dataIndex == 1? 'black' : getDatasetBackgroundColor(ctx.dataset.label);
            }
          }
        },
        scales: {
          xAxes: [{
            type: 'linear',
            position: 'bottom',
            ticks: {
              fontColor: '#a7a7a7',
              padding: 10
            },
            gridLines: {
              drawOnChartArea: false,
              drawTicks: false,
              zeroLineColor: 'white'
            },
          }],
          yAxes: [{
            type: 'linear',
            labels: this.chartdata.yLabels,
            position: 'left',
            ticks: {
              min: 0,
              max: this.chartdata.yLabels.length,
              stepSize: 1,
              fontColor: '#a7a7a7',
              padding: 10,
              callback: (value, index, values) => {
                return this.chartdata.yLabels[value - 1]? this.chartdata.yLabels[value - 1] : ""
              },
            },
            gridLines: {
              drawOnChartArea: false,
              drawTicks: false,
              zeroLineColor: 'white'
            },
          }, 
          ],
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          callbacks: {
            label: (tooltipItem, data) => {
              var dataSetLength = data.datasets[tooltipItem.datasetIndex].data.length
              var tooltipItemIdx = tooltipItem.index

              var label = dataSetLength == 1? 'Unique': getTooltipLabel(tooltipItemIdx);

              if (label) {
                  label += ': ';
              }
              label += Math.round(tooltipItem.xLabel * 100) / 100;
              return label;
            }
          }
        },
      }

      this.loading = false;
    } catch (error) {
      Vue.toasted.error(error, { duration: 3500 });
      return;
    }
  }, // end mounted
}

const initWidgetData = (data) => {
  var widgData = {};

  var yLabels = []
  var yValue = 1
  widgData.datasets = []

  data.data.sort((datasetB, datasetA) => getDatasetOrder(datasetA.trailer) - getDatasetOrder(datasetB.trailer))
  data.data.forEach((element, i) => {
    // Build Chart Dataset
    var label = getDatasetLabel(element.trailer)
    yLabels.push(label)

    var widgDataset = {};
    widgDataset.label = label
    widgDataset.backgroundColor = getDatasetBackgroundColor(label)
    widgDataset.pointHitRadius = 5
    widgDataset.borderCapStyle = 'round'
    widgDataset.pointWidth = 5
    widgDataset.lineTension = 0
    widgDataset.showLine = true
    widgDataset.data = []

    // Build Dataset Points
    var widgPointMin = {};
    widgPointMin.x = element.min
    widgPointMin.y = yValue
    widgDataset.data.push(widgPointMin)
    
    if(element.min < element.median){
      var widgPointMed = {};
      widgPointMed.x = element.median
      widgPointMed.y = yValue
      widgDataset.data.push(widgPointMed)
    }

    if(element.min < element.max){
      var widgPointMax = {};
      widgPointMax.x = element.max
      widgPointMax.y = yValue
      widgDataset.data.push(widgPointMax)
    }
    
    widgDataset.data.sort((elementA, elementB) => elementA.x - elementB.x)
    widgData.datasets.push(widgDataset)
    yValue++
  });

  

  yLabels.push("")
  widgData.yLabels = yLabels
  return widgData
}

const getTooltipLabel = (idx) => {
  switch(idx){
    case 0:
      return "Min"
    case 1:
      return "Typical"
    case 2:
      return "Max"
    default:
      return ""
  }
}

const getDatasetLabel = (id) => {
  switch(id){
    case "Flatbed":
      return "Flatbed"
    case "Container Chassis":
      return "Container"
    case "Reefer Fresh":
      return "Reefer-Fresh"
    case "Reefer Frozen":
      return "Reefer-Frozen"
    case "Heated":
      return "Heated"
    case "Dry Van":
      return "Dry"
    default:
      return id
  }
}

const getDatasetBackgroundColor = (label) => {
  switch(label){
    case "Flatbed":
      return "#bb5dff"
    case "Container":
      return "#473dfb"
    case "Reefer-Fresh":
      return "#57bc45"
    case "Reefer-Frozen":
      return "#07b5fb"
    case "Heated":
      return "#fb145a"
    case "Dry":
    default:
      return "#e5e5e5"
  }
}

const getDatasetOrder = (id) => {
  switch(id){
    case "Dry Van":
      return 1
    case "Flatbed":
      return 2
    case "Container Chassis":
      return 3
    case "Reefer Fresh":
      return 4
    case "Reefer Frozen":
      return 5
    case "Heated":
      return 6
    default:
      return 10
  }
}
</script>



// WEBPACK FOOTER //
// CostTonneKMWidget.vue?0bdec52e